/* eslint-disable react/prefer-es6-class, react/sort-comp */
import classnames from 'classnames';
import Localization from 'es6/services/localization';
import React from 'react';

export const SessionProgressSteps = React.createClass({
  displayName: 'SessionProgressSteps',

  propTypes: {
    progress: React.PropTypes.number.isRequired,
    totalSteps: React.PropTypes.number,
  },

  render() {
    const steps = [];

    for (let i = 0; i < this.props.totalSteps; i++) {
      steps.push(this._renderStep(i));
    }

    return (
      <div className="session-progress">
        <span className="text">{Localization.t('js_iknow.session progress')}</span>
        <ul className="steps">
          {steps}
        </ul>
      </div>
    );
  },

  _renderStep(i) {
    const className = classnames('step', { 'step-filled': i <= this.props.progress });

    return (
      <li key={i} className={className} />
    );
  },
});

export default SessionProgressSteps;
